import { useLoggedUserContext } from '../../AppContext';
import sessionClient from '../../infrastructure/sessionClient';
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import UIError from "../UIError";
import LoadingPopup from '../loading/LoadingPopup';
import ErrorPopup from "../error/ErrorPopup";

export default function GameServerPanel({gameServer}) {
    const setLoggedUser = useLoggedUserContext()[1];
    const navigate = useNavigate();

    const openAdminQuery = useMutation({mutationFn: async () => await openAdmin(gameServer)});

    return <div>
        {openAdminQuery.isError && renderError(openAdminQuery.error, setLoggedUser, navigate)}
        {(openAdminQuery.isPending || openAdminQuery.isSuccess) && <LoadingPopup/>}
        <button onClick={() => openAdminQuery.mutate()}>{gameServer.name} ({gameServer.id})</button>
    </div>
}

async function openAdmin(gameServer) {
    const res = await sessionClient.getToken();
    
    if (res.ok) {
        const json = await res.json();
        const token = json.token;
        window.location = `${gameServer.url}/api/session/start?token=${token}`;
    }
    else if (res.status === 401) {
        throw new UIError("UNAUTHORIZED");
    }
    else {
        throw new UIError("Error status code: " + res.status);
    }
}

function renderError(error, setLoggedUser, navigate) {
    if (error.name === "UIError" && error.message === "UNAUTHORIZED") {
        setTimeout(() => {
            setLoggedUser(null);
            navigate('/login');
        });
        return null;
    }

    return <ErrorPopup message={error.message}/>
}
